import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar, faFolderOpen, faFolderClosed, faDollarSign, faClock } from '@fortawesome/free-solid-svg-icons';

const MiniDashboardPaymentAdvances = ({ 
    numberOfAdvances, 
    totalOpen, 
    totalClosed, 
    totalOpenedAmount, 
    averageAging 
}) => {
  return (
    <div className="bg-white shadow rounded-lg p-3 w-full mb-4">
      <div className="grid grid-cols-4 divide-x divide-gray-200 text-center">
        <div className="py-2">
          <FontAwesomeIcon icon={faFolderOpen} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Open Advances</p>
          <p className="text-lg font-semibold text-gray-800">{totalOpen}</p>
        </div>
        <div className="py-2">
          <FontAwesomeIcon icon={faFolderClosed} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Closed Advances</p>
          <p className="text-lg font-semibold text-gray-800">{totalClosed}</p>
        </div>
        <div className="py-2">
          <FontAwesomeIcon icon={faDollarSign} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Opened Amount</p>
          <p className="text-lg font-semibold text-gray-800">{totalOpenedAmount}</p>
        </div>
        <div className="py-2">
          <FontAwesomeIcon icon={faClock} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Average Aging</p>
          <p className="text-lg font-semibold text-gray-800">{averageAging.toFixed(2)} days</p>
        </div>
      </div>
    </div>
  );
};

export default MiniDashboardPaymentAdvances;
